import { formatCardKey } from '@/ai/utils/helpers'
import { buildPrompt } from '@/ai/utils/promptBuilder'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createUserMessage, createSystemMessage } from '@/ai/utils/promptUtils'
import { buildWorkflowSpec, buildCardTypesMap } from '@/shared/utils/workflowSpec'
import { DomainModelRole } from '@/constants/cardTypes'

export const buildSingleCardPrompt = ({
  eventId,
  workflow,
  cardTypes,
  cardTypeId
}) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []
  const cardType = cardTypes.find((cardType) => cardType.id === cardTypeId)
  const cardTypeTitle = cardType.title

  const event = workflow.domainEvents.find((e) => e.id === eventId)
  const laneMap = new Map((workflow.lanes || []).map((l) => [l.id, l.name]))
  const roleName = laneMap.get(event?.laneId) || ''
  const isTagType = cardType.domainModelRole === DomainModelRole.TAG

  promptSections.push({
    title: 'Request',
    content: [
      `Suggest one ${cardTypeTitle} (${cardType.description}) to be added to domain event "${event?.description}" (${roleName}).`,
      `The ${cardTypeTitle} must be relevant to the workflow and the domain event as a whole and must not already exist in the workflow.`
    ]
  })

  const cardTypesMap = buildCardTypesMap(cardTypes)

  promptSections.push({
    title: 'Current Workflow Specification (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: buildWorkflowSpec(workflow, null, cardTypesMap) || '{}'
  })

  const cardExample = isTagType
    ? { [formatCardKey(cardTypeTitle)]: ['tag1', 'tag2', 'tag3'] }
    : { [formatCardKey(cardTypeTitle)]: 'Example text' }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting(formatCardKey(cardTypeTitle), JSON.stringify(cardExample))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
